import WithAuth from "../components/hoc/with-auth";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx";
import { Flex, Text, Box, Skeleton } from "@chakra-ui/react";
import FrequentTradesPage from "../components/pages/frequent-trades-page";
import CreateTransactionsForm from "../components/pages/create-transactions-form";
import CreateUserForm from "../components/pages/create-user-form";
import { useQuery } from "react-query";
import { getAllGroups } from "../services/crm.service";
import _ from "lodash";
import ErrorBoundary from "../components/ErrorBoundary";

const CreateUser = () => {
  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
    refetch,
  } = useQuery(["all-groups"], () => getAllGroups(), {});

  return (
    <>
      <WithAuth>
        <LayoutWithSidebar pageTitle="Create User" pageDesc="User account.">
          <ErrorBoundary>
            {isLoading ? (
              <Skeleton minHeight="500px" width="100%" />
            ) : (
              //@ts-ignore
              <CreateUserForm
                groups={_.isEmpty(data?.data?.data) ? [] : data?.data?.data}
              />
            )}
          </ErrorBoundary>
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default CreateUser;
